export default {
    'multiple-languages': {
        title: 'Versie 2.3: Keybreak spreekt zeven talen',
        excerpt: 'Versie 2.3 brengt ondersteuning voor meerdere talen: de hele app en de website zijn nu beschikbaar in zeven talen, en er komen er meer.',
    },
    'micro-breaks': {
        title: 'Versie 2.2: Micropauzes',
        excerpt: 'Na feedback van gebruikers voegt versie 2.2 micropauzes toe: elke 10–15 minuten een kleine tip in de hoek van je scherm met één ding om te proberen.',
    },
    'dynamic-hold-system': {
        title: 'Versie 2.1: Slimmere houdtijden en betere feedback',
        excerpt: 'Versie 2.1 brengt twee dingen: een manier om de houdtijd ter plekke te verlengen, en een nieuw animatiesysteem dat je precies laat zien waar je bent in elke houding.',
    },
    'science-of-sitting': {
        title: 'De wetenschap van zitten: wat onderzoek zegt over de hele dag zitten',
        excerpt: 'Zittend gedrag is een op zichzelf staand gezondheidsrisico, grotendeels los van hoeveel je sport. Dit is wat het onderzoek echt laat zien.',
    },
    'benefits-of-moving': {
        title: 'Waarom meer bewegen tijdens je werkdag echt telt',
        excerpt: 'Regelmatige beweegpauzes helpen niet alleen je lichaam. Ze maken je scherper, minder moe en in de loop van de dag productiever.',
    },
    'keybreak-launch': {
        title: 'Keybreak: je slimme maatje voor pauzes',
        excerpt: 'Na maanden van ontwikkeling zijn we ontzettend blij dat Keybreak officieel beschikbaar is, gratis te downloaden voor Mac en Windows.',
    },
}
